import React from 'react'
import { makeStyles } from '@material-ui/core'
import { gray } from '../../utils/colors'

const useStyles = makeStyles((theme) => ({
	root: {
		minWidth: '9.375rem',
		padding: '.3rem',
		border: `0.0625rem solid ${gray[300]}`,
		borderRadius: '4px',
		fontFamily: 'Nunito',
		background: gray[300],
		color: gray[800]
	}
}))
/**
 *
 * @param {{value: any, options: [{value: any, label: string}], onValueChanged: (value: string) => any}} param0
 * @returns
 */
const StyledSimpleSelect = ({ value, options, onValueChanged }) => {
	const classes = useStyles()

	if (!options) {
		return null
	}

	const handleOnValueChanged = (e) => {
		if (onValueChanged) {
			onValueChanged(e.target.value)
		}
	}
	return (
		<select value={value} className={classes.root} onChange={handleOnValueChanged}>
			{options.map((option) => {
				const { value, label, disabled = false } = option
				return (
					<option key={`simple-select-option-${value}`} value={value} disabled={disabled}>
						{label}
					</option>
				)
			})}
		</select>
	)
}

export default StyledSimpleSelect
